import { Reducer } from "redux"
import { BatchEditType, AuthUserType } from "../../../Actions/Types"
import { unique } from "../../../Helpers/Functions/array"
import { updateAt } from "../../../Helpers/Functions/reducer"
import { RouterAction, LOCATION_CHANGE } from "connected-react-router"
import { UserAction } from "../../Auth/UserReducer"

export interface BatchEditEntry {
    selected: string[]
}

export interface BatchEditState {
    [id: string]: BatchEditEntry | undefined
}

interface BatchEditEnterAction {
    type: BatchEditType.enterBatchMode
    meta: {
        id: string
    }
}

interface BatchEditExitAction {
    type: BatchEditType.exitBatchMode
    meta: {
        id: string
    }
}

interface BatchEditAddToSelectionAction {
    type: BatchEditType.addToSelection
    meta: {
        id: string
    }
    payload: string[]
}

interface BatchEditRemoveFromSelectionAction {
    type: BatchEditType.removeFromSelection
    meta: {
        id: string
    }
    payload: string[]
}

interface BatchEditClearSelectionAction {
    type: BatchEditType.clearSelection
    meta: {
        id: string
    }
}

interface BatchEditToggleSelectionAction {
    type: BatchEditType.toggleSelection
    meta: {
        id: string
    }
    payload: string[]
}

export type BatchEditAction =
    | BatchEditEnterAction
    | BatchEditExitAction
    | BatchEditAddToSelectionAction
    | BatchEditRemoveFromSelectionAction
    | BatchEditClearSelectionAction
    | BatchEditToggleSelectionAction

const initialState: BatchEditState = {}

const createInitialEntry = () => ({
    selected: []
})

export const BatchEditReducer: Reducer<
    BatchEditState,
    BatchEditAction | RouterAction | UserAction
> = (state = initialState, action): BatchEditState => {
    switch (action.type) {
        case BatchEditType.enterBatchMode:
            return {
                ...state,
                [action.meta.id]: createInitialEntry()
            }
        case BatchEditType.exitBatchMode:
            return {
                ...state,
                [action.meta.id]: undefined
            }
        case BatchEditType.addToSelection:
            return updateAt(state, action.meta.id, entry => ({
                ...entry,
                selected:
                    entry === undefined
                        ? action.payload
                        : unique(entry.selected.concat(action.payload))
            }))
        case BatchEditType.removeFromSelection:
            return updateAt(state, action.meta.id, entry => ({
                ...entry,
                selected:
                    entry === undefined
                        ? []
                        : entry.selected.filter(
                              s => !action.payload.includes(s)
                          )
            }))
        case BatchEditType.clearSelection:
            return updateAt(state, action.meta.id, entry => ({
                ...entry,
                selected: []
            }))
        case BatchEditType.toggleSelection:
            return updateAt(state, action.meta.id, entry => ({
                ...entry,
                selected:
                    entry === undefined
                        ? action.payload
                        : entry.selected
                              .filter(s => !action.payload.includes(s))
                              .concat(
                                  action.payload.filter(
                                      s => !entry.selected.includes(s)
                                  )
                              )
            }))
        case LOCATION_CHANGE:
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
